import { Brand, Environment } from '@crystal/config'
import { glassConfig } from '@crystal/glass-bridge'

export const getProdRedirectUrl = (path: string, brand: Brand, locale: string, env: Environment) => {
  const siteUrl = glassConfig.evaluateWithContext({ brand, locale, env }).siteUrl
  return `${siteUrl}${path}`
}
